/* eslint-disable */
import React, { useEffect } from 'react';
import classes from './Mortgage.module.css';
import { useSelector } from 'react-redux';
import { Slider } from '@mui/material';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// import { useState } from 'react';

const PrettoSlider = styled(Slider)({
  color: 'var(--primary-clr)',
  height: 8,
  marginBottom: '-10px',
  '& .MuiSlider-track': {
    height: '8px',
    border: 'none',
    backgroundColor: 'var(--primary-clr)'
  },
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: 'var(--primary-clr)',
    border: '4px solid var(--white-clr)',
    boxShadow: '2px 2px 10px #00000094',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: '2px 2px 10px #00000094'
    },
    '&:before': {
      display: 'none'
    }
  },
  '& .MuiSlider-rail': {
    opacity: 0.3,
    backgroundColor: 'var(--primary-clr)',
    borderRadius: '0px !important',
    height: '8px'
  }
});

const MortgageCalculator = ({
  heading = 'Mortgage Calculator',
  // data = {
  //   principalAmount: 'AED 422000',
  //   interestRate: '16.6%',
  //   downPayment: '16.6%',
  //   totalInterestAmount: '573363 AED',
  //   monthlyCost: '21000 AED',
  //   totalCost: '422000 AED',
  //   interestAmount: '573362 AED',
  //   loanAmount: '422000 AED'
  // },
  tKey = 'propertyDetail',
  isMortgageLoanPage = false
}) => {
  const { t } = useTranslation(tKey);
  const { currency } = useSelector((state) => state?.converterReducer);
  console.log('currency', currency);
  const [propertyValue, setPropertyValue] = useState(100000);
  const [loanPeriod, setLoanPeriod] = useState(2);
  const [interest, setInterest] = useState(0.1);
  const [downPayment, setDownPayment] = useState(2);

  const [data, setData] = useState({
    principalAmount: `${currency.symbol} 422000`,
    interestRate: '16.6%',
    downPayment: '16.6%',
    totalInterestAmount: `${currency.symbol} 573363`,
    monthlyCost: `${currency.symbol} 21000`,
    totalCost: `${currency.symbol} 422000`,
    interestAmount: `${currency.symbol} 573362`,
    loanAmount: `${currency.symbol} 422000`
  });

  const minMaxValues = {
    propertyValue: {
      min: 0,
      max: 100000000
    },
    loanPeriod: {
      min: 1,
      max: 30
    },
    interest: {
      min: 0.1,
      max: 10
    },
    downPayment: {
      min: 1,
      max: 99
    }
  };


  useEffect(() => {
    setData({
      principalAmount: `${currency.symbol} 422000`,
      interestRate: '16.6%',
      downPayment: '16.6%',
      totalInterestAmount: `${currency.symbol} 573363`,
      monthlyCost: `${currency.symbol} 21000`,
      totalCost: `${currency.symbol} 422000`,
      interestAmount: `${currency.symbol} 573362`,
      loanAmount: `${currency.symbol} 422000`
    })
  }, [currency]);

  useEffect(() => {
    calculateValues();
  }, []);

  useEffect(() => {
    calculateValues();
  }, [propertyValue, loanPeriod, interest, downPayment]);

  const calculateValues = () => {
    const principalAmount = propertyValue - downPayment;
    const monthlyInterestRate = interest / 100 / 12;
    const numberOfPayments = loanPeriod * 12;

    const monthlyCost =
      (principalAmount *
        (monthlyInterestRate * Math.pow(1 + monthlyInterestRate, numberOfPayments))) /
      (Math.pow(1 + monthlyInterestRate, numberOfPayments) - 1);

    const totalCost = monthlyCost * numberOfPayments;
    const totalInterestAmount = totalCost - principalAmount;

    setData({
      principalAmount: `${currency.symbol} ${principalAmount.toFixed(2)}`,
      interestRate: `${interest}%`,
      downPayment: `${((downPayment / propertyValue) * 100).toFixed(2)}%`,
      totalInterestAmount: `${totalInterestAmount.toFixed(2)} ${currency.symbol}`,
      monthlyCost: `${monthlyCost.toFixed(2)} ${currency.symbol}`,
      totalCost: `${totalCost.toFixed(2)} ${currency.symbol}`,
      interestAmount: `${totalInterestAmount.toFixed(2)} ${currency.symbol}`,
      loanAmount: `${currency.symbol} ${principalAmount.toFixed(2)}`
    });
  };

  return (
    <>
      <style>
        {`
            .slider .MuiSlider-root{
                margin-bottom:-8px
            }

            `}
      </style>
      <div className={!isMortgageLoanPage && classes.main}>
        {/* <HeadingWithUnderline underlineColor="var(--secondary-clr)"> */}
        <h5 className={classes.Morg}>{heading || t('mortgage.title')}</h5>
        {/* </HeadingWithUnderline> */}

        <Row className={!isMortgageLoanPage ? classes.row : classes.rowLoanPage}>
          <Col className={!isMortgageLoanPage && classes.col} md={!isMortgageLoanPage && 6}>
            <div className={classes.sliderBox}>
              <div className={classes.head}>
                <div>{t('mortgage.range1')}</div>
                <div className={classes.valueBox}>
                  {/* <span>{propertyValue}
                  </span> */}
                  <span>
                    {/* <p>abcc</p> */}
                    <input
                      min={0}
                      max={100000000}
                      type="number"
                      value={propertyValue}
                      onChange={(e) => {
                        const inputValue = e.target.value;

                        if (inputValue === '') {
                          setPropertyValue('');
                        } else {
                          const value = Math.min(100000000, Number(inputValue));
                          setPropertyValue(value);
                        }
                      }}
                      className={classes.input}
                    />
                  </span>

                  <span>{currency.symbol}</span>
                </div>
              </div>
              {/* propertyValue */}
              <div className={classes.slider}>
                <PrettoSlider
                  value={propertyValue || 100000}
                  onChange={(val) => {
                    setPropertyValue(val.target.value);
                  }}
                  aria-label="Default"
                  valueLabelDisplay="auto"
                  min={minMaxValues.propertyValue.min}
                  step={1000}
                  max={minMaxValues.propertyValue.max}
                />
              </div>
              {/* <div className={`flex-sb ${classes.range}`}>
                <span>{minMaxValues.propertyValue.min.toLocaleString()} </span>
                <span>{minMaxValues.propertyValue.max.toLocaleString()} </span>
              </div> */}
            </div>
            {/* loanPeriod */}
            <div>
              <div className={classes.sliderBox}>
                <div className={classes.head}>
                  <div>{t('mortgage.range2')}</div>
                  <div className={classes.valueBox}>
                    {' '}
                    {/* <span>{loanPeriod}</span> */}
                    <span>
                      <input
                        min={1}
                        max={30}
                        type="number"
                        value={loanPeriod}
                        onChange={(e) => {
                          const inputValue = e.target.value;

                          if (inputValue === '') {
                            setLoanPeriod('');
                          } else {
                            const value = Math.min(30, Number(inputValue));
                            setLoanPeriod(value);
                          }
                        }}
                        className={classes.input}
                      />
                    </span>
                    <span>Years</span>
                  </div>
                </div>
                <div className={classes.slider}>
                  <PrettoSlider
                    value={loanPeriod}
                    onChange={(val) => {
                      setLoanPeriod(val.target.value);
                    }}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={minMaxValues.loanPeriod.min}
                    max={minMaxValues.loanPeriod.max}
                  />
                </div>
              </div>
              {/* <div className={`flex-sb ${classes.range}`}>
                <span>{minMaxValues.loanPeriod.min.toLocaleString()} Year</span>
                <span>{minMaxValues.loanPeriod.max.toLocaleString()} Year</span>
              </div> */}
            </div>
            {/* interest */}
            <div>
              <div className={classes.sliderBox}>
                <div className={classes.head}>
                  <div>{t('mortgage.range3')}</div>
                  <div className={classes.valueBox}>
                    {' '}
                    {/* <span>{interest}</span> */}
                    <span>
                      <input
                        type="number"
                        value={interest}
                        min={0}
                        max={10}
                        step="0.1"
                        onChange={(e) => {
                          const inputValue = e.target.value;

                          if (inputValue === '') {
                            setInterest('');
                          } else {
                            const value = Math.min(10, Number(inputValue));
                            setInterest(value);
                          }
                        }}
                      />
                    </span>
                    <span>%</span>
                  </div>
                </div>
                <div className={classes.slider}>
                  <PrettoSlider
                    value={interest}
                    onChange={(val) => {
                      setInterest(val.target.value);
                    }}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={minMaxValues.interest.min}
                    step={0.1}
                    max={minMaxValues.interest.max}
                  />
                </div>
              </div>
              {/* <div className={`flex-sb ${classes.range}`}>
                <span>{minMaxValues.interest.min.toLocaleString()} </span>
                <span>{minMaxValues.interest.max.toLocaleString()} </span>
              </div> */}
            </div>
            {/* downPayment */}
            <div>
              <div className={classes.sliderBox}>
                <div className={classes.head}>
                  <div>{t('mortgage.downPayment')}</div>
                  <div className={classes.valueBox}>
                    {' '}
                    {/* <span>{downPayment}</span> */}
                    <span>
                      <input
                        type="number"
                        value={downPayment}
                        min={1}
                        max={99}
                        onChange={(e) => {
                          const inputValue = e.target.value;

                          if (inputValue === '') {
                            setDownPayment('');
                          } else {
                            const value = Math.min(99, Number(inputValue));
                            setDownPayment(value);
                          }
                        }}
                      />
                    </span>
                    <span>%</span>
                  </div>
                </div>
                <div className={classes.slider}>
                  <PrettoSlider
                    value={downPayment}
                    onChange={(val) => {
                      setDownPayment(val.target.value);
                    }}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={minMaxValues.downPayment.min}
                    max={minMaxValues.downPayment.max}
                  />
                </div>
              </div>
              {/* <div className={`flex-sb ${classes.range}`}>
                <span>
                  {minMaxValues.downPayment.min} {t('mortgage.year')}
                </span>
                <span>
                  {minMaxValues.downPayment.max} {t('mortgage.year')}
                </span>
              </div> */}
            </div>
            {/*  */}
          </Col>
          <Col className={!isMortgageLoanPage && classes.col} md={!isMortgageLoanPage && 6}>
            <div className={classes.rightColBorder}>
              <div className={classes.cost}>
                <h5>{t('mortgage.totalCost')}</h5>
                <h4 data-color={'primary'}>{data?.totalCost}</h4>
              </div>
              <div className={classes.cost2}>
                <h4>{data?.monthlyCost}</h4>
                <h5>{t('mortgage.monthlyCost')}</h5>
              </div>

              {!isMortgageLoanPage && (
                <div className={classes.onlyBorder}>
                  <Row className={classes.mainRow}>
                    <Col md={12} className="pb-2">
                      <Row>
                        <Col lg={6} md={6}>
                          <h6>{t('mortgage.principalAmount')}</h6>
                        </Col>
                        <Col lg={6} md={6}>
                          <p>{data?.principalAmount}</p>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={12} className="pb-2">
                      <Row>
                        <Col lg={6} md={6}>
                          <h6>{t('mortgage.interestRate')}</h6>
                        </Col>
                        <Col lg={6} md={6}>
                          <p>{data?.interestRate}</p>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={12} className="pb-2">
                      <Row>
                        <Col lg={6} md={6}>
                          <h6>{t('mortgage.downPayment')}</h6>
                        </Col>
                        <Col lg={6} md={6}>
                          <p>{data?.downPayment}</p>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={12} className="pb-2">
                      <Row>
                        <Col lg={6} md={6}>
                          <h6>{t('mortgage.totalInterestAmount')}</h6>
                        </Col>
                        <Col lg={6} md={6}>
                          <p>{data?.totalInterestAmount}</p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              )}

              <div className={classes.col2Head}>
                <div className={classes.head2}>
                  <h6>{data?.loanAmount}</h6>
                  <p>{t('mortgage.loanAmount')}</p>
                </div>

                <div className={classes.head1}>
                  <h6>{data?.interestAmount}</h6>
                  <p>{t('mortgage.interest')}</p>
                </div>
              </div>
              {/* <div className={classes.col2Cost}>
                <div className={classes.cost}>
                  <h5>{t('mortgage.monthlyCost')}</h5>
                  <h4>{data?.monthlyCost}</h4>
                </div>
                <div className={classes.cost}>
                  <h5>{t('mortgage.totalCost')}</h5>
                  <h4 data-color={'primary'}>{data?.totalCost}</h4>
                </div>
              </div> */}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MortgageCalculator;
